import React, { useState } from 'react';
import { Brikk } from 'components/Brikk';
import volunteer from 'assets/media/volunteer.jpg';
import Draggable from 'components/drag-and-drop/Draggable';
import { NewPageButton } from 'components/form-elements/buttons/NewPageButton';
import { VolunteerIcon } from 'assets/icons/brikks/VolunteerIcon';
import { LinkBrikkContent } from 'components/brikks/sub-components/LinkBrikkContent';
import { CircularImage } from 'components/brikks/sub-components/CircularImage';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';

export const VolunteerTime = ({ position, status, code, name }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };
  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<VolunteerIcon />}
            heading="Volunteer Your Time"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <CircularImage
              src={volunteer}
              alt="Person helping the elderly"
            />

            <LinkBrikkContent link="lund.se" />
          </Brikk.Content>

          <Brikk.Button>
            <NewPageButton
              label="Volunteer Your Time Link"
              to="https://lund.se/"
              brikkNameIntl="Volunteer"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Volunteer time info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />
    </>
  );
};
